import React from "react";
import Blogs from "../components/blog";
import Footer from "../components/footer";
import Header from "../components/header";

const BlogPage = () => {
  return (
    <div>
      <Header />
      <Blogs />
      <Footer />
    </div>
  );
};

export default BlogPage;
